import { useState } from "react";
import CustomerSupportView from "@/components/CustomerSupport/CustomerSupport.view"
import useCustomerSupporti18n from "@/i18n/useCustomerSupporti18n"

const CustomerSupport = props => {
  const { data: authorData = {}, genericListData } = props
  const staticText = useCustomerSupporti18n(authorData)
  const tabTypes = ["Service Request", "Feedback"]
  const [activeTab, setActiveTab] = useState(tabTypes[0])
  return (
    <>
      <CustomerSupportView
        staticText={staticText}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabTypes={tabTypes}
        serviceRequest={genericListData?.serviceRequest ?? []}
        productDetails={genericListData?.productDetails ?? []}
        authorData={authorData}
      />
    </>
  )
}

export default CustomerSupport
